import { RowNode } from 'ag-grid-community';
import { FilterInterface } from '../components';
import { isRxAdminEnabled } from '../redux/helpers';
import { AnyType } from '../interfaces';

export const filterGridComparator = (node: RowNode, filter?: FilterInterface, filterMapping?: any) => {
  let showNode = false;
  switch (filter?.primaryFilter?.toLowerCase()) {
    case 'actions':
      if (node.data.rxAdminAlert && isRxAdminEnabled()) {
        showNode = node.data.rxAdminAlert;
      } else {
        showNode = node.data.actionAlert || !!node.data.actionAlertCount;
      }
      break;

    case 'updates':
      showNode = node.data.updateAlert || !!node.data.updateAlertCount;
      break;

    case 'pending':
      if (
        filterMapping?.pending
          .map((pending: string) => pending.toLowerCase())
          .includes(node.data.statusText?.toLowerCase())
      ) {
        showNode = true;
      }
      break;

    case 'complete':
      if (
        filterMapping?.complete
          .map((complete: string) => complete.toLowerCase())
          .includes(node.data.statusText?.toLowerCase()) &&
        node.data.actionAlertCount == 0 &&
        node.data.updateAlertCount == 0
      ) {
        showNode = true;
      }
      break;

    case 'enrollement':
      if (
        filterMapping?.enrollment
          .map((enrollment: string) => enrollment.toLowerCase())
          .includes(node.data.statusText?.toLowerCase()) &&
        node.data.actionAlertCount == 0 &&
        node.data.updateAlertCount == 0
      ) {
        showNode = true;
      }
      break;

    default:
      showNode = true;
  }
  return showNode;
};

export const getStatusDescriptions = (data: AnyType[], typeName: string) => {
  const statusDescriptions: string[] = [
    ...new Set(
      data.reduce((acc: string[], curr: AnyType) => {
        if (curr?.statusText) {
          acc = [...acc, curr.statusText];
        }
        return acc;
      }, [])
    )
  ];
  return statusDescriptions.map((item) => ({ statusDescription: item, __typename: typeName }));
};
